import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDurationOneWeek = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={3.5} width={3} height={3} rx={1.5} stroke="#919499" />
    <rect x={8.5} y={9.5} width={3} height={3} rx={1.5} stroke="#919499" />
    <path d="M3.5 5h9a3 3 0 1 1 0 6H11" stroke="#919499" />
  </svg>
);
const Memo = memo(SvgDurationOneWeek);
export default Memo;
